export class AlertReportFilter {
  publisherIds?: string[];
  impressionsDropPercent?: number;
  revenueDropPercent?: number;
  refreshDropPercent?: number;
  revenueDropAmount?: number;
  revenueDiscrepancyOver?: number;
  revenueOver?: number;
  impressionsOver?: number;
  dateFrom?: string;
  dateTo?: string;
}
